<template>
  <v-row class="ma-0" align="center" justify="center">
    <v-col align="center">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
      <p class="mt-4">ログイン中...</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  async mounted() {
    try {
      // 既存のセッションをクリア
      this.$store.commit('user/logout', {})

      // URLクエリパラメータからトークン情報を取得
      const query = this.$route.query
      const accessToken = query['access-token']
      const client = query['client']
      const uid = query['uid']

      if (!accessToken || !client || !uid) {
        this.$toasted.global.error({ message: '認証情報が不足しています' })
        this.$router.push('/sign_in')
        return
      }

      // axiosのヘッダーにトークンを設定
      this.$axios.defaults.headers.common['access-token'] = accessToken
      this.$axios.defaults.headers.common['client'] = client
      this.$axios.defaults.headers.common['uid'] = uid

      // ユーザー情報を取得
      const res = await this.$axios.get('/api/v1/auth/validate_token')
      const userData = res.data.data

      // 認証情報をstoreに格納
      const auth = {
        accessToken: accessToken,
        client: client,
        uid: uid,
        userId: userData.id
      }
      this.$store.commit('user/login', auth)
      this.$store.commit('user/setRole', { role: userData.type })
      this.$store.commit('user/setLastOperatedDate', { lastOperatedDate: new Date() })
      this.$store.commit('user/setUserId', { userId: userData.id })
      this.$store.commit('user/setIsDemo', { isDemo: userData.is_demo })
      this.$store.commit('user/setRemainingDownloadCount', { remainingDownloadCount: userData.remaining_download_count })
      this.$store.commit('user/setAccountType', { accountType: userData.account_type })

      // マスタデータ取得
      await this.$store.dispatch('master/getMasterData')

      // 先生アカウントの場合、所属学校データを取得
      if (this.$store.getters['user/isTeacher']) {
        const url = `api/v1/schools/${userData.school_id}`
        const school = await this.$axios(url)
        this.$store.commit('user/setSchoolData', { schoolData: school.data })
        // 担当教科をリセット
        this.$store.commit('setSubjectTeachers', [])
        // 進学アカウント判定
        const subjectTeachersResponse = await this.$axios.get('/api/v1/teacher/subject_teachers')
        this.$store.commit('user/setIsShingaku', { isShingaku: subjectTeachersResponse.data.some(st => st.is_shingaku) })
      }

      // ホームにリダイレクト
      this.$router.push(this.$store.getters['user/homePath'])
    } catch (error) {
      console.error('SSO認証エラー:', error)
      this.$toasted.global.error({ message: 'SSO認証に失敗しました' })
      this.$router.push('/sign_in')
    }
  }
}
</script>

<style lang="stylus" scoped>
.row
  height 100%
</style>
